/* Cards side by side, filling the width; one column when narrow (ADR 0019). The columns
   follow the width of the content panel, not the window, so an open sidebar is counted.
   What follows the grid is spaced by the parent's gap, like stacked cards. */
.frame {
  min-width: 0;
  container-type: inline-size;
}

.grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  align-items: stretch;
  gap: var(--space-5);
  min-width: 0;
}

.grid > [data-span='full'] {
  grid-column: 1 / -1;
}

@container (width >= 720px) {
  .grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@container (width >= 1100px) {
  .grid[data-columns='3'] {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (width < 640px) {
  .grid {
    gap: var(--space-4);
  }
}
